import React from "react";
import { Box, Slide, Stack } from "@mui/material";
import PageHeader from "./../../components/PageHeader";
import TransactionRow from "../../components/TransactionRow";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import { useTranslation } from "react-i18next";
export default function TransactionHistory() {
  const { t } = useTranslation("common");
  const [transactions, setTransactions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getTransaction = async () => {
    try {
      setLoading(true);
      const response = await ApiService.TRANSACTIONS();
      setTransactions(response["result"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    getTransaction();
  }, []);
  return (
    <Slide direction="left" in={true} mountOnEnter unmountOnExit>
      <Box>
        <PageHeader title="Transaction History" />
        <Box className="__main_pading">
          <Stack spacing={2} sx={{ maxHeight: "83vh", overflow: "scroll" }}>
            {transactions.length > 0 ? (
              transactions.map((transaction, index) => (
                <TransactionRow key={index} transaction={transaction} />
              ))
            ) : (
              <NoData lable={t("noData.message20")} />
            )}
          </Stack>
        </Box>
        {loading ? <Loader /> : null}
      </Box>
    </Slide>
  );
}
